__turbopack_context__.v({
  "bodyText": "BlockRichText-module-scss-module__TdFjRW__bodyText",
  "flushBottom": "BlockRichText-module-scss-module__TdFjRW__flushBottom",
  "flushTop": "BlockRichText-module-scss-module__TdFjRW__flushTop",
  "link": "BlockRichText-module-scss-module__TdFjRW__link",
  "richTextBlock": "BlockRichText-module-scss-module__TdFjRW__richTextBlock",
});
